import React from "react";

const LeaveIcon = ({ color }) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <path d="M6 7h12l-1 14H7L6 7z" stroke={color} strokeWidth="1.5" />
      <path d="M9 7V5a3 3 0 016 0v2" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export default LeaveIcon;
